import { Box, CardBody, Card, Flex, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { AvatarBubbles } from '../../../../shared/AvatarBubbles/AvatarBubbles'
import { ClientTeamMembership } from '../../../../../types/clientTeamMembership'

export const MSG = defineMessages({
  heading: {
    id: 'FoundPreferredAgentCard.heading',
    defaultMessage: 'Real Estate Agent'
  },
  license: {
    id: 'FoundPreferredAgentCard.license',
    defaultMessage: 'License #{license}'
  }
})

export const FoundPreferredAgentCard = ({
  agent,
  corporateProfile
}: {
  agent: ClientTeamMembership['customerProfile']
  corporateProfile: ClientTeamMembership['corporateProfile']
}) => {
  const intl = useIntl()

  return (
    <Card size='sm'>
      <CardBody>
        <Flex alignItems='center' justifyContent='space-between' mb='0'>
          <Box>
            <Heading
              as='h3'
              size='3xs'
              variant='eyebrow'
              color='neutral.700'
              fontWeight='semibold'
              mb='0'
              textAlign='left'
            >
              {intl.formatMessage(MSG.heading)}
            </Heading>
            <Text color='neutral.900' fontWeight='bold' mb='0'>
              {agent.firstName} {agent.lastName}
            </Text>
            <Text size='sm' fontWeight='semibold' mb='0'>
              {corporateProfile?.name}
            </Text>
            {agent.stateLicense && (
              <Text color='neutral.800' size='3xs' mb='0'>
                {intl.formatMessage(MSG.license, { license: agent.stateLicense })}
              </Text>
            )}
          </Box>
          {(agent.photoUri || corporateProfile?.avatarUri) && (
            <AvatarBubbles photoUri={agent.photoUri} companyLogo={corporateProfile?.avatarUri} />
          )}
        </Flex>
      </CardBody>
    </Card>
  )
}
